var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1C5.0293 1 1 5.0293 1 10C1 14.9707 5.0293 19 10 19C14.9707 19 19 14.9707 19 10C19 5.0293 14.9707 1 10 1Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.04297 15.711C3.04297 15.711 5.04907 13.1496 9.99907 13.1496C14.9491 13.1496 16.9561 15.711 16.9561 15.711M9.99907 9.99961C10.7152 9.99961 11.4019 9.71515 11.9083 9.2088C12.4146 8.70245 12.6991 8.01569 12.6991 7.29961C12.6991 6.58352 12.4146 5.89677 11.9083 5.39042C11.4019 4.88407 10.7152 4.59961 9.99907 4.59961C9.28298 4.59961 8.59623 4.88407 8.08988 5.39042C7.58353 5.89677 7.29907 6.58352 7.29907 7.29961C7.29907 8.01569 7.58353 8.70245 8.08988 9.2088C8.59623 9.71515 9.28298 9.99961 9.99907 9.99961Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9b9cdfe0ba46f3bd4085bc4f54ec14b0.svg";
export { ForwardRef as ReactComponent };